/*
 * Marks UI that an OPEN island's own editor rendered but that React portalled
 * out of the island's DOM subtree — today, the condition @-picker's popover.
 *
 * The island dismisses itself when focus or a pointerdown lands anywhere that
 * is not inside its wrapper, because that reads as "the clinician went
 * somewhere else". A portalled popover breaks that test: it is the island's own
 * UI, opened by the island's own content, but Radix renders it under
 * `document.body`, so a containment check on the wrapper says the clinician
 * left. Pressing `@` therefore dismissed the island and unmounted the picker
 * with it, in the same tick the picker took focus.
 *
 * This is deliberately NOT `data-ai-suggestion-surface`, which means something
 * else: "an accept surface that reads the open island's live content, so do not
 * unmount the island as I am activated". Reusing it here would widen a marker
 * that currently guards two specific components into a general
 * do-not-dismiss-for-this flag, and would leave no way to tell the two reasons
 * apart later.
 *
 * Scope note: the attribute is not island-scoped, because only one island can
 * hold focus at a time and a picker is only ever opened from the island that
 * has it.
 */
export const ISLAND_PORTAL_ATTRIBUTE = 'data-ai-island-portal'

export const ISLAND_PORTAL_SELECTOR = `[${ISLAND_PORTAL_ATTRIBUTE}]`

// Spread onto the portalled element itself, so the attribute string has one
// source and `closest` finds it from anything focused inside.
export const islandPortalAttributes = { [ISLAND_PORTAL_ATTRIBUTE]: '' }
